import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-[var(--main-bg)]">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[var(--obsidian)] border-t-transparent animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-bold" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            Loading...
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;